import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconReceipt: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18.1242C9.52004 18.1242 9.04009 17.9417 8.67426 17.5758L6.99091 15.8933C6.77091 15.675 6.42084 15.6508 6.17334 15.8358L5.04175 16.685C4.59675 17.0183 4.01089 17.0708 3.51506 16.8225C3.01756 16.5742 2.70837 16.0742 2.70837 15.5183V5C2.70837 2.985 3.81837 1.875 5.83337 1.875H14.1667C16.1817 1.875 17.2917 2.985 17.2917 5V15.5175C17.2917 16.0733 16.9825 16.5733 16.485 16.8217C15.9892 17.07 15.4033 17.0175 14.9583 16.6842L13.8258 15.8342C13.5792 15.6492 13.2275 15.6733 13.0092 15.8925L11.3258 17.575C10.96 17.9417 10.48 18.1242 10 18.1242ZM6.54667 14.4633C7.03084 14.4633 7.51333 14.6483 7.875 15.0092L9.55835 16.6925C9.79418 16.9283 10.2059 16.9283 10.4425 16.6925L12.1259 15.01C12.7817 14.3542 13.8375 14.2808 14.5758 14.8358L15.7092 15.6858C15.7992 15.7542 15.8834 15.7267 15.9276 15.7058C15.9701 15.6842 16.0425 15.6317 16.0425 15.5192V5C16.0425 3.68583 15.4817 3.125 14.1675 3.125H5.83419C4.52002 3.125 3.95919 3.68583 3.95919 5V15.5175C3.95919 15.63 4.03174 15.6825 4.07424 15.7042C4.11841 15.7258 4.20171 15.7525 4.29254 15.6842L5.42505 14.8342C5.75672 14.5858 6.1525 14.4633 6.54667 14.4633ZM13.9584 7.5C13.9584 7.155 13.6784 6.875 13.3334 6.875H9.16671C8.82171 6.875 8.54171 7.155 8.54171 7.5C8.54171 7.845 8.82171 8.125 9.16671 8.125H13.3334C13.6784 8.125 13.9584 7.845 13.9584 7.5ZM13.9584 10.8333C13.9584 10.4883 13.6784 10.2083 13.3334 10.2083H9.16671C8.82171 10.2083 8.54171 10.4883 8.54171 10.8333C8.54171 11.1783 8.82171 11.4583 9.16671 11.4583H13.3334C13.6784 11.4583 13.9584 11.1783 13.9584 10.8333ZM6.66671 6.875C6.32171 6.875 6.04171 7.155 6.04171 7.5C6.04171 7.845 6.32171 8.125 6.66671 8.125C7.01171 8.125 7.29171 7.845 7.29171 7.5C7.29171 7.155 7.01171 6.875 6.66671 6.875ZM6.66671 10.2083C6.32171 10.2083 6.04171 10.4883 6.04171 10.8333C6.04171 11.1783 6.32171 11.4583 6.66671 11.4583C7.01171 11.4583 7.29171 11.1783 7.29171 10.8333C7.29171 10.4883 7.01171 10.2083 6.66671 10.2083Z"
      fill={color}
    />
  </svg>
);

export default IconReceipt;
